import styled from "styled-components";
import { useAppSelector } from "../../../../../redux";
import { FlexRow } from "../../../../Common/Styles";
import UserInfo from "../../../../Common/UserInfo";

export const UserDetails = () => {
  const { profile_picture, first_name, last_name, headline, id } =
    useAppSelector((state) => state.me);
  const name = `${first_name} ${last_name}`;

  return (
    <Container >
      <UserInfo
        id={id}
        headline={headline}
        name={name}
        profile_picture={profile_picture}
        avatarSize="Small-40"
        showUserInfoOnHover={false}
      />
    </Container>
  );
};

const Container = styled(FlexRow)`
  border-radius: ${({ theme }) => theme.radius["radius-xs"].value}rem;
  padding: ${({ theme }) => theme.spacing["spacing-3"].value}rem
    ${({ theme }) => theme.spacing["spacing-2"].value}rem;

  &:hover {
    background: ${({ theme }) =>
      theme.Color.elevation.surface["surface-primary-hover"].value};
  }
`;
